'use strict';

function MoneyEducational() {
  this.id = null;
  this.node = null;
  this.extends = [_AccountController, Educational];

  this.contentId = ''; // 'money' (defined in pug file)

  this.init = function () {
    this._super();
    this.initPage();
  };

  this.initPage = function () {
    this.initEducational();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyEducational();
  };
}